<div>
  <span class="dollar-symbol">{{ dollarSymbol }}</span>
  <span class="dollars" [attr.data-test-id]="testId || null">{{ dollars }}</span>
  <span class="cents"
    >{{ isDisplayingDecimalSeparator ? '.' : '' }}{{ cents }}</span
  >
</div>
